// Configuration for the frontend
export const API_URL = process.env.API_URL  ||  "https://test.roboticsonwheels.in";
